import React from "react";


const DashboardTimeTable = (props) => {
    const days = [
        { id: '1', dayName: 'Monday' },
        { id: '2', dayName: 'Tuesday' },
        { id: '3', dayName: 'Wednesday' },
        { id: '4', dayName: 'Thursday' },
        { id: '5', dayName: 'Friday' },
        { id: '6', dayName: 'Saturday' },
    ]
    const t_id = parseInt(new Date().getDay());
    return (
        <div className="card  ">
            <div className="card-header position-relative py-0 border-bottom-2">
                <h3 className="mt-3 pb-3">My Timetable</h3>
            </div>
            <div className="card-body">
                <div className="list-tab mb-4 mt-3">
                    <ul className="nav">
                        {
                            days.map((x, y) => {
                                const active = x.id === t_id.toString() ? 'show active' : ''
                                return (
                                    <li key={y}>
                                        <a href="#" className={`${active}`} data-bs-toggle="tab"  data-bs-target={`#${x.id}`}>{x.dayName}</a>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
                <div className="tab-content">
                    <div className="tab-pane fade" id="1">
                        <div className="event-wrapper event-scroll">
                            {
                                props.timetable.filter(x => x.DayName === 'Monday').length > 0 ?
                                    props.timetable.filter(x => x.DayName === 'Monday').map((item, index) => {
                                        const classes = ["success", "danger", "info", "secondary", "primary", "default"];
                                        let random = "";
                                        for (let index = 0; index < props.timetable.length; index++) {

                                            random = Math.floor(Math.random() * classes.length);
                                        }
                                        return (

                                            <div key={index} className={`border-start border-${classes[random]} border-3 shadow-sm p-3 mb-3`}>
                                                <div className="d-flex align-items-center mb-3 pb-3 border-bottom">
											<span className="avatar p-1 me-2 bg-teal-transparent flex-shrink-0">
												<i className="ti ti-calendar text-info fs-20"></i>
											</span>
                                                    <div className="flex-fill">
                                                        <h6 className="mb-1">{item.ModuleCode} : {item.ModuleName}</h6>
                                                        <p className="d-flex align-items-center" style={{fontSize: '18px'}}><i className="ti ti-clock  me-1"></i> {item.StartTime} - {item.EndTime}</p>
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <p className="mb-0"><i className="ti ti-pin me-1"></i> Venue: {item.VenueName}   <span className='badge badge-secondary'>{item.ModuleType}</span></p>
                                                    <div className="avatar-list-stacked avatar-group-sm">

                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }) : <div className="text-center alert alert-info mb-3">No timetable schedule for the selected day</div>
                            }
                        </div>
                    </div>
                    <div className="tab-pane fade" id="2">
                        <div className="event-wrapper event-scroll">
                            {
                                props.timetable.filter(x => x.DayName === 'Tuesday').length > 0 ?
                                    props.timetable.filter(x => x.DayName === 'Tuesday').map((item, index) => {
                                        const classes = ["success", "danger", "info", "secondary", "primary", "default"];
                                        let random = "";
                                        for (let index = 0; index < props.timetable.length; index++) {

                                            random = Math.floor(Math.random() * classes.length);
                                        }
                                        return (

                                            <div key={index} className={`border-start border-${classes[random]} border-3 shadow-sm p-3 mb-3`}>
                                                <div className="d-flex align-items-center mb-3 pb-3 border-bottom">
											<span className="avatar p-1 me-2 bg-teal-transparent flex-shrink-0">
												<i className="ti ti-calendar text-info fs-20"></i>
											</span>
                                                    <div className="flex-fill">
                                                        <h6 className="mb-1">{item.ModuleCode} : {item.ModuleName}</h6>
                                                        <p className="d-flex align-items-center" style={{fontSize: '18px'}}><i className="ti ti-clock  me-1"></i> {item.StartTime} - {item.EndTime}</p>
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <p className="mb-0"><i className="ti ti-pin me-1"></i> Venue: {item.VenueName}   <span className='badge badge-secondary'>{item.ModuleType}</span></p>
                                                    <div className="avatar-list-stacked avatar-group-sm">

                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }) : <div className="text-center alert alert-info mb-3">No timetable schedule for the selected day</div>
                            }
                        </div>
                    </div>
                    <div className="tab-pane fade" id="3">
                        <div className="event-wrapper event-scroll">
                            {
                                props.timetable.filter(x => x.DayName === 'Wednesday').length > 0 ?
                                    props.timetable.filter(x => x.DayName === 'Wednesday').map((item, index) => {
                                        const classes = ["success", "danger", "info", "secondary", "primary", "default"];
                                        let random = "";
                                        for (let index = 0; index < props.timetable.length; index++) {

                                            random = Math.floor(Math.random() * classes.length);
                                        }
                                        return (

                                            <div key={index} className={`border-start border-${classes[random]} border-3 shadow-sm p-3 mb-3`}>
                                                <div className="d-flex align-items-center mb-3 pb-3 border-bottom">
											<span className="avatar p-1 me-2 bg-teal-transparent flex-shrink-0">
												<i className="ti ti-calendar text-info fs-20"></i>
											</span>
                                                    <div className="flex-fill">
                                                        <h6 className="mb-1">{item.ModuleCode} : {item.ModuleName}</h6>
                                                        <p className="d-flex align-items-center" style={{fontSize: '18px'}}><i className="ti ti-clock  me-1"></i> {item.StartTime} - {item.EndTime}</p>
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <p className="mb-0"><i className="ti ti-pin me-1"></i> Venue: {item.VenueName}   <span className='badge badge-secondary'>{item.ModuleType}</span></p>
                                                    <div className="avatar-list-stacked avatar-group-sm">

                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }) : <div className="text-center alert alert-info mb-3">No timetable schedule for the selected day</div>
                            }
                        </div>
                    </div>
                    <div className="tab-pane fade" id="4">
                        <div className="event-wrapper event-scroll">
                            {
                                props.timetable.filter(x => x.DayName === 'Thursday').length > 0 ?
                                    props.timetable.filter(x => x.DayName === 'Thursday').map((item, index) => {
                                        const classes = ["success", "danger", "info", "secondary", "primary", "default"];
                                        let random = "";
                                        for (let index = 0; index < props.timetable.length; index++) {

                                            random = Math.floor(Math.random() * classes.length);
                                        }
                                        return (

                                            <div key={index} className={`border-start border-${classes[random]} border-3 shadow-sm p-3 mb-3`}>
                                                <div className="d-flex align-items-center mb-3 pb-3 border-bottom">
											<span className="avatar p-1 me-2 bg-teal-transparent flex-shrink-0">
												<i className="ti ti-calendar text-info fs-20"></i>
											</span>
                                                    <div className="flex-fill">
                                                        <h6 className="mb-1">{item.ModuleCode} : {item.ModuleName}</h6>
                                                        <p className="d-flex align-items-center" style={{fontSize: '18px'}}><i className="ti ti-clock  me-1"></i> {item.StartTime} - {item.EndTime}</p>
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <p className="mb-0"><i className="ti ti-pin me-1"></i> Venue: {item.VenueName}   <span className='badge badge-secondary'>{item.ModuleType}</span></p>
                                                    <div className="avatar-list-stacked avatar-group-sm">

                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }) : <div className="text-center alert alert-info mb-3">No timetable schedule for the selected day</div>
                            }
                        </div>
                    </div>
                    <div className="tab-pane fade" id="5">
                        <div className="event-wrapper event-scroll">
                            {
                                props.timetable.filter(x => x.DayName === 'Friday').length > 0 ?
                                    props.timetable.filter(x => x.DayName === 'Friday').map((item, index) => {
                                        const classes = ["success", "danger", "info", "secondary", "primary", "default"];
                                        let random = "";
                                        for (let index = 0; index < props.timetable.length; index++) {

                                            random = Math.floor(Math.random() * classes.length);
                                        }
                                        return (

                                            <div key={index} className={`border-start border-${classes[random]} border-3 shadow-sm p-3 mb-3`}>
                                                <div className="d-flex align-items-center mb-3 pb-3 border-bottom">
											<span className="avatar p-1 me-2 bg-teal-transparent flex-shrink-0">
												<i className="ti ti-calendar text-info fs-20"></i>
											</span>
                                                    <div className="flex-fill">
                                                        <h6 className="mb-1">{item.ModuleCode} : {item.ModuleName}</h6>
                                                        <p className="d-flex align-items-center" style={{fontSize: '18px'}}><i className="ti ti-clock  me-1"></i> {item.StartTime} - {item.EndTime}</p>
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <p className="mb-0"><i className="ti ti-pin me-1"></i> Venue: {item.VenueName}   <span className='badge badge-secondary'>{item.ModuleType}</span></p>
                                                    <div className="avatar-list-stacked avatar-group-sm">

                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }) : <div className="text-center alert alert-info mb-3">No timetable schedule for the selected day</div>
                            }
                        </div>
                    </div>
                    <div className="tab-pane fade" id="6">
                        <div className="event-wrapper event-scroll">
                            {
                                props.timetable.filter(x => x.DayName === 'Saturday').length > 0 ?
                                    props.timetable.filter(x => x.DayName === 'Saturday').map((item, index) => {
                                        const classes = ["success", "danger", "info", "secondary", "primary", "default"];
                                        let random = "";
                                        for (let index = 0; index < props.timetable.length; index++) {

                                            random = Math.floor(Math.random() * classes.length);
                                        }
                                        return (

                                            <div key={index} className={`border-start border-${classes[random]} border-3 shadow-sm p-3 mb-3`}>
                                                <div className="d-flex align-items-center mb-3 pb-3 border-bottom">
											<span className="avatar p-1 me-2 bg-teal-transparent flex-shrink-0">
												<i className="ti ti-calendar text-info fs-20"></i>
											</span>
                                                    <div className="flex-fill">
                                                        <h6 className="mb-1">{item.ModuleCode} : {item.ModuleName}</h6>
                                                        <p className="d-flex align-items-center" style={{fontSize: '18px'}}><i className="ti ti-clock  me-1"></i> {item.StartTime} - {item.EndTime}</p>
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <p className="mb-0"><i className="ti ti-pin me-1"></i> Venue: {item.VenueName}   <span className='badge badge-secondary'>{item.ModuleType}</span></p>
                                                    <div className="avatar-list-stacked avatar-group-sm">

                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }) : <div className="text-center alert alert-info mb-3">No timetable schedule for the selected day</div>
                            }
                        </div>
                    </div>

                </div>
            </div>

            {/*end: Card Body*/}
        </div>
    )

}
export default DashboardTimeTable;